import React from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { AnimateSlideInContent, AnimateSlideInMask } from './index.style'
import { useContext } from 'react'
import { StoreState } from '../../../Store'

const AnimateSlideIn = ({
  direction = 'bottom',
  duration = 0.5,
  delay = 0,
  triggerOnce = true,
  animate = true,
  children,
}) => {
  const [ref, inView] = useInView({ triggerOnce })
  const store = useContext(StoreState)
  const { showTransitionMask } = store

  return (
    <AnimateSlideInMask ref={ref}>
      <AnimateSlideInContent
        inView={inView && animate && !showTransitionMask}
        direction={direction}
        duration={duration}
        delay={delay}
      >
        {children}
      </AnimateSlideInContent>
    </AnimateSlideInMask>
  )
}

AnimateSlideIn.propTypes = {
  children: PropTypes.node.isRequired,
  delay: PropTypes.number,
  duration: PropTypes.number,
  triggerOnce: PropTypes.bool,
  animate: PropTypes.bool,
  direction: PropTypes.oneOf(['top', 'right', 'left', 'bottom']),
}

export default AnimateSlideIn
